<template>
  <div
    class="crop-container"
    ref="cropContainer"
    :style="{ 'background-color': backgroundColor }"
  >
    <template v-if="!video">
      <div
        v-show="loading"
        class="image-mask-container"
        :style="{ 'background-color': backgroundColor }"
      >
        <img
          src="../../../../public/images/common/image_loading.png"
          class="mask-img"
        />
      </div>
      <div class="crop-line-container">
        <!--锁定样式超出区域显示黑色-->
        <div class="lock-crop-container" v-if="model.lock">
          <div
            class="top-crop mask-container"
            :style="{ 'background-color': backgroundColor }"
          ></div>
          <div class="center-crop" :style="{ height: cropStyle.height }">
            <div
              class="let-crop mask-container"
              :style="{
                height: cropStyle.height,
                width: cropWidth,
                'background-color': backgroundColor,
              }"
            ></div>
            <div class="center-crop-container" :style="cropStyle"></div>
            <div
              class="right-crop mask-container"
              :style="{
                height: cropStyle.height,
                width: cropWidth,
                'background-color': backgroundColor,
              }"
            ></div>
          </div>
          <div
            class="bottom-crop mask-container"
            :style="{ 'background-color': backgroundColor }"
          ></div>
        </div>
      </div>
      <img
        class="crop-image"
        :class="imageFilter"
        :style="imageStyle"
        :src="model.url"
        ondragstart="return false;"
      />
    </template>
    <hi-video
      v-else
      :poster="media.coverUrl"
      :src="media.url"
      style="width: 100%; height: 100%"
    ></hi-video>
  </div>
</template>

<script>
import { getInitImgParams } from "../../../utils/media";
import hiVideo from "../../common/media/Video";

export default {
  name: "CropItemComponent",
  components: { hiVideo },
  props: {
    media: {
      type: Object,
      default: null,
    },
    model: {
      // 图片裁切参数
      type: Object,
    },
    thumbnail: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: "#e9eef1",
    },
  },
  data() {
    return {
      cropSize: 0,
      full: false, // 是否切换到全屏模式
      loading: false, // 图片是否处于加载状态
      minScale: 1,
      maxScale: 5,
    };
  },
  computed: {
    // 计算是否为视频
    video() {
      if (!this.media) {
        return false;
      }
      return this.media.type === 2;
    },
    imageFilter() {
      if (this.video) {
        return {};
      }
      if (this.filter) {
        return this.filter;
      }
      return this.model.filter;
    },
    cropWidth() {
      if (this.video) {
        return {};
      }
      if (this.cropStyle.w) {
        const cropSize = this.cropSize;
        // 为防止由于4舍5入造成宽度不足导致遮挡不完整 +1像素线
        return `${(cropSize - this.cropStyle.w) / 2 + 1}px`;
      }
      return 0;
    },
    /**
     * 计算裁切框样式
     */
    cropStyle() {
      if (this.video) {
        return {};
      }
      if (this.cropSize === 0 || !this.model.image) {
        return {};
      }
      const cropSize = this.cropSize;
      let width, height;
      // 宽度大于高度则宽度顶满
      if (this.model.percentage > 1) {
        width = cropSize;
        height = width / this.model.percentage;
      } else {
        height = cropSize;
        width = height * this.model.percentage;
      }
      return {
        width: `${width}px`,
        w: width,
        h: height,
        height: `${height}px`,
      };
    },
    imageStyle() {
      if (this.video) {
        return {};
      }
      if (this.cropSize === 0 || !this.model.image) {
        return {};
      }
      const cropSize = this.cropSize;
      // 获取距离左上角距离
      let realX = this.model.x * cropSize;
      let realY = this.model.y * cropSize;
      // 计算图片的宽高比例
      const imageRatio = this.model.image.width / this.model.image.height;
      // 计算宽相对于裁切容器比例
      let width;
      if (imageRatio > 1) {
        // 宽大于高则说明宽是1
        width = this.model.scale * cropSize;
      } else {
        width = this.model.scale * cropSize * imageRatio;
      }
      const height = width / imageRatio;
      let h = height / cropSize;
      let w = width / cropSize;
      let offset = 0;
      if (this.model.rotate % 180 !== 0) {
        // 旋转之后修正坐标偏移量
        offset = (height - width) / 2;
        h = width / cropSize;
        w = height / cropSize;
      }
      return {
        h, // 图片高
        w, // 图片宽
        offset: offset / cropSize, // 修正值 如果图片翻转则坐标需要修正
        height: `${height}px`,
        width: `${width}px`,
        transform: `translate(${realX + offset}px,${realY - offset}px) rotate(${
          this.model.rotate
        }deg)`,
      };
    },
  },
  methods: {
    // 清空当前图片对应各种tag
    clearTag() {
      // 保存之后清空所有tag
      this.media.story_mentions = [];
      this.media.story_hashtags = [];
      this.media.usertags = [];
      this.media.product_tags = [];
    },
    switchFull() {
      this.full = !this.full;
      // 强制回到最小值
      this.shrink(-100);
    },
    /**
     * 旋转
     */
    async rotate() {
      this.model.rotate += 90;
      // 超过1圈重新计算
      if (this.model.rotate === 360) {
        this.model.rotate = 0;
      }
      const params = await getInitImgParams({ model: this.model });
      this.minScale = params.minScale;
      this.maxScale = params.maxScale;
      this.scale = params.scale;
      console.log("rotate() {", this.scale);
      // 重置一下缩放
      this.shrink(0);
      this.moving({ relativeX: 0, relativeY: 0 });
      this.clearTag();
    },
    /**
     * 缩小图片
     */
    shrink(num) {
      let scale = this.model.scale + num;
      let minScale = this.minScale;
      let maxScale = this.maxScale;
      // 如果开启全屏模式则要求短边= 1
      if (this.full && !this.model.lock) {
        if (this.imageStyle.w > this.imageStyle.h) {
          minScale = this.imageStyle.w / this.imageStyle.h;
        } else {
          minScale = this.imageStyle.h / this.imageStyle.w;
        }
      }
      if (scale < minScale) {
        scale = minScale;
      }
      if (scale > maxScale) {
        scale = maxScale;
      }
      if (this.model.scale !== scale) {
        this.clearTag();
      }
      this.model.scale = scale;
      // 缩放之后原地移动一下 保证样式
      this.moving({ relativeX: 0, relativeY: 0 });
    },
    /**
     * 移动中
     */
    async moving({ relativeX, relativeY }) {
      const corpSize = this.cropSize;
      // 计算实际偏移像素
      let x = (this.model.x * corpSize + relativeX) / corpSize;
      let y = (this.model.y * corpSize + relativeY) / corpSize;
      // 计算x的左右极限
      let minX = 0;
      let maxX = 0;
      let minY = 0;
      let maxY = 0;
      let imageWidth = this.imageStyle.w;
      let imageHeight = this.imageStyle.h;
      // 如果发现是锁定逻辑则调整最大最小值
      if (this.model.lock) {
        let lockWidth = 1;
        let lockHeight = 1;
        // 宽大于高则
        if (this.model.percentage > 1) {
          lockHeight = 1 / this.model.percentage;
        } else {
          lockWidth = this.model.percentage;
        }
        // 计算极限
        maxX = (1 - lockWidth) / 2;
        maxY = (1 - lockHeight) / 2;
        minX = 1 - imageWidth - maxX;
        minY = 1 - imageHeight - maxY;
      } else {
        // 如果横向宽度已经大于裁切容器宽度则说明需要计算
        if (imageWidth > 1) {
          minX = 1 - imageWidth;
          maxX = 0;
        } else {
          minX = maxX = (1 - imageWidth) / 2;
        }
        // 如果纵向宽度已经大于裁切容器宽度则说明需要计算
        if (imageHeight > 1) {
          minY = 1 - imageHeight;
          maxY = 0;
        } else {
          minY = maxY = (1 - imageHeight) / 2;
        }
      }
      if (x <= minX) {
        x = minX;
      }
      if (x >= maxX) {
        x = maxX;
      }
      if (y <= minY) {
        y = minY;
      }
      if (y >= maxY) {
        y = maxY;
      }
      if (this.model.y !== y || this.model.x !== x) {
        this.clearTag();
        this.$emit("changeImg");
      }
      this.model.y = y;
      this.model.x = x;
    },
    /**
     * 移动结束
     */
    moveEnd() {
      this.state = "start";
    },
  },
  /**
   * 初始化裁切组件
   * @return {Promise<void>}
   */
  async mounted() {
    if (this.video) {
      return;
    }
    this.loading = true;
    const elCrop = this.$refs.cropContainer;
    this.cropSize = elCrop.clientWidth;
    // 预览模式就不做移动逻辑
    if (!this.thumbnail) {
      elCrop.onmousedown = (e) => {
        let x = e.pageX;
        let y = e.pageY;
        // 监听坐标变化
        e.preventDefault();
        // 同时监听鼠标移动
        document.onmousemove = (e) => {
          // 计算移动后坐标
          let relativeX = e.pageX - x;
          let relativeY = e.pageY - y;
          x = e.pageX;
          y = e.pageY;
          this.moving({ relativeX, relativeY });
        };
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
      // 如果是视频的话改成add状态这样每次都会裁切
      if (!this.video) {
        this.media.from = "add";
      }
    }
    this.loading = false;
    const params = await getInitImgParams({ model: this.model });
    this.minScale = params.minScale;
    this.maxScale = params.maxScale;
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme";

.image-mask-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  .mask-img {
    width: 50%;
    max-width: 60px;
    display: block;
  }
}

.lock-crop-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;

  .mask-container {
    background-color: #e9eef1;
  }

  .top-crop,
  .bottom-crop,
  .let-crop,
  .right-crop {
    flex: 1;
  }

  .top-crop,
  .bottom-crop {
    width: 100%;
  }

  .center-crop {
    display: flex;

    .center-crop-container {
      background-color: rgba(0, 0, 0, 0);
      color: white;
    }
  }
}

.crop-container {
  width: 400px;
  height: 400px;
  position: relative;
  background: #e5e5e5;
  overflow: hidden;

  .crop-line-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1;
  }

  .crop-img {
    transform-origin: left top;
  }
  .crop-image {
    image-orientation: 0deg;
  }
}
</style>
